import { render, staticRenderFns } from "./nav-bar-new.vue?vue&type=template&id=6314e1db"
import script from "./nav-bar-new.vue?vue&type=script&lang=js"
export * from "./nav-bar-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports